import { publicUserSchema } from '@ghp/domain';
import { bearer } from './http.js';
/** Ce que le compte connecté lit **de lui-même**. */
export function createMeEndpoints(http) {
    return {
        /** Le compte connecté — initiales, nom, rôle, pour le bandeau. */
        profile(accessToken) {
            return http.get('/me', publicUserSchema, bearer(accessToken));
        },
    };
}
//# sourceMappingURL=me.js.map